module.exports = "<template> <sio-editor config.bind=field value.bind=field.value></sio-editor> </template> ";